import request from '@/config/axios'

// 竞价租户详情（机构信息 + 报价），字段以后端 BiddingTenantRespVO 为准
export interface BiddingTenantRespVO {
  id: number // 租户编号
  name: string // 租户名（竞价机构名称）
  contactName: string // 联系人
  contactMobile: string // 联系手机
  status: number // 租户状态（0正常 1停用）
  accountCount: number // 账号数量
  expireTime: string // 过期时间
  createTime: string // 创建时间
  email: string // 邮箱
  officialWebsite: string // 官网
  address: string // 地址
  introduction: string // 机构简介
  inventionPrice: number // 发明专利代理价格（元）
  utilityModelPrice: number // 实用新型专利代理价格（元）
  appearancePrice: number // 外观设计专利代理价格（元）
}

// 获取竞价租户详情（机构信息）
export const getBiddingTenantDetail = (id: number) => {
  return request.get<BiddingTenantRespVO>({
    url: '/tenant-manage/bidding/tenant-detail',
    params: { id }
  })
}

// 竞价租户编辑保存的请求参数，字段以后端 BiddingTenantSaveReqVO 为准
export interface BiddingTenantSaveReqVO {
  id: number // 租户编号（必填）
  status: number // 租户状态 0正常 1停用（必填）
  contactName?: string // 联系人
  contactMobile?: string // 联系手机
  email?: string // 邮箱
  officialWebsite?: string // 官网
  address?: string // 地址
  introduction?: string // 机构简介
  inventionPrice?: number // 发明专利代理价格（元）
  utilityModelPrice?: number // 实用新型专利代理价格（元）
  appearancePrice?: number // 外观设计专利代理价格（元）
}

// 编辑保存竞价租户（机构信息 + 报价）
export const editBiddingTenant = (data: BiddingTenantSaveReqVO) => {
  return request.put<boolean>({
    url: '/tenant-manage/bidding/tenant-edit',
    data
  })
}
